import { createAsyncThunk } from '@reduxjs/toolkit';
export const getTypeVar = createAsyncThunk(
  'get_type_variable',
  async (argument, thunkAPI) => {
    try {
      const res = await thunkAPI.extra.typeVariable.getTypeVariableById(
        argument
      );
      return res.data.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data.errorMessages);
    }
  }
);
